import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=7644ca70&"
import script from "./Flag.vue?vue&type=script&lang=js&"
export * from "./Flag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports